var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevuudApprovedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33397 20C3.07346 20 2.88737 19.9436 2.77573 19.8309C2.66408 19.6994 2.58034 19.5209 2.52451 19.2955L0.012406 6.13507C-0.0248105 5.90962 0.0217061 5.72175 0.151964 5.57145C0.282221 5.42116 0.477609 5.34601 0.738124 5.34601H3.69683C4.10621 5.34601 4.34812 5.56206 4.42255 5.99417L5.76234 14.5893L14.1595 0.591797C14.3828 0.197266 14.6899 0 15.0806 0H18.2941C18.4616 0 18.5918 0.046968 18.6849 0.140904C18.7779 0.216052 18.8244 0.328776 18.8244 0.479074C18.8244 0.591797 18.7779 0.723307 18.6849 0.873604L7.43708 19.2955C7.28822 19.5209 7.13005 19.6994 6.96257 19.8309C6.81371 19.9436 6.60902 20 6.3485 20H3.33397Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevuudApprovedIcon);
export default __webpack_public_path__ + "static/media/revuudApprovedIcon.5593e153.svg";
export { ForwardRef as ReactComponent };